/**
 * Haber kartı (fallback). CMS hata verince i18n: `newsList.fallbackItems`.
 * @typedef {{
 *   id: string,
 *   imageUrl: string,
 *   publishedAt: string,
 *   title: string,
 *   excerpt: string,
 *   href: string,
 * }} HaberListItem
 */

/**
 * @param {unknown} raw
 * @returns {HaberListItem[]}
 */
export function mapNewsFallbackFromI18n(raw) {
    if (!Array.isArray(raw)) return [];
    return raw
        .filter((x) => x && typeof x === 'object')
        .map((x) => {
            const o = /** @type {Record<string, unknown>} */ (x);
            return {
                id: String(o.id ?? ''),
                imageUrl: String(o.imageUrl ?? ''),
                publishedAt: String(o.publishedAt ?? ''),
                title: String(o.title ?? ''),
                excerpt: String(o.excerpt ?? ''),
                href: String(o.href ?? '/#'),
            };
        })
        .filter((x) => x.id && x.imageUrl && x.title);
}
